import { Component } from '@angular/core';

@Component({
  selector: 't-lib-unknown-app',
  standalone: true,
  imports: [],
  templateUrl: './unknown-app.component.html',
  styleUrl: './unknown-app.component.css',
})
export class UnknownAppComponent {}
